<template>
    
    <component :is="tag" 
        @click="route($event)"
        @click.middle="route($event)">

        <slot></slot>

    </component>

</template>

<script>

import { goTo } from '@/router'

export default {

    props: {

        tag: {
            type: String,
            required: true,
        },

        url: {
            type: String,
            default: null,
            required: false,
        }
    },

    methods: {

        route: function(event) {

            if ( !this.url ) {
                return
            }

            // clique + ctrl
            // clique bouton molette 
            if ( event.ctrlKey === true
                || event.button === 1 ) {
                goTo(this.url, true)
            }
            
            // clique simple
            else {
               goTo(this.url)
            }
        }
    }
}

</script>